import { render, staticRenderFns } from "./dashboardReportsCrm.vue?vue&type=template&id=e7f87d36&"
import script from "./dashboardReportsCrm.vue?vue&type=script&lang=js&"
export * from "./dashboardReportsCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports